import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import AttendanceListNewView from "./attendanceListNew.view";
import * as AttendanceService from "../../../../services/AttendanceService";
import * as SessionService from "../../../../services/SessionService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";
import { useAttendance } from "../hook/useAttendance";
import PATHS from "../../../../constants/paths";
import moment from "moment";
import "moment/locale/es";

const AttendanceListNewContainer = ({ uuid, session }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [forceRefresh, setForceRefresh] = useState(false);

  // const loadAttendees = () => {
  //   setForceRefresh(!forceRefresh);
  // };
  useEffect(() => {
    if (forceRefresh) {
      setForceRefresh(false);
    }
  }, [forceRefresh]);

  const refresh = () => {
    setForceRefresh(true);
  };

  const listAttendees = async (filter) => {
    try {
      const filterParams = {
        sessionUuid: uuid,
        sort: "name",
        page: filter.page || 1,
        pageSize: filter.pageSize || 20,
      };
      const result = await AttendanceService.listFilter(filterParams);
      return result;
    } catch (error) {
      console.error("Error loading attendees:", error);
      return { docs: [], page: 1, hasNextPage: false };
    }
  };

  const { signAttendance, createViewer } = useAttendance(refresh);

  const handleSignAttendance = (attendeeUuid) => {
    signAttendance(attendeeUuid);
  };

  const handleCreateViewer = (sessionUuid) => {
    createViewer(sessionUuid);
  };

  const handleDeleteAttendance = (attendeeUuid) => {
    const okAction = async () => {
      try {
        const result = await AttendanceService.deleteAttendance(attendeeUuid);
        if (result === "OK") {
          // loadAttendees();
          setForceRefresh(true);
        }
      } catch (error) {
        console.error("Error deleting attendee:", error);
      }
    };

    ShowAlertDialog(
      t("forms.form.dialog.remove.title"),
      t("forms.form.dialog.remove.text"),
      "warning",
      true,
      t("forms.form.dialog.remove.buttonOk"),
      false,
      okAction,
      t("forms.form.dialog.remove.buttonNo"),
      () => {}
    );
  };

  const handleGenerateDocument = async () => {
    if (uuid !== null) {
      try {
        const result = await SessionService.generateDocument(uuid);
        const session = await SessionService.getSession(uuid);
        const year = moment(session.date).year();
        const month = moment(session.date).month() + 1;
        const day = moment(session.date).date();
        const nameCourse = session.session.meeting?.course?.name.replace(
          /\s+/g,
          ""
        );
        const url = window.URL.createObjectURL(result);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${year}_${month}_${day}_${nameCourse}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        if (result) {
          ShowAlertDialog(
            t("forms.attendance.messages.download.title"),
            t("forms.attendance.messages.download.success"),
            "success",
            false,
            "OK",
            false
          );
        } else {
          ShowAlertDialog(
            "Error",
            t("forms.attendance.messages.download.error"),
            "error",
            false,
            "OK",
            false
          );
        }
      } catch (error) {
        console.error("Error generating document:", error);
        ShowAlertDialog(
          "Error",
          t("forms.attendance.messages.download.error"),
          "error",
          false,
          "OK",
          false
        );
      }
    }
  };

  const handleBack = () => {
    navigate(PATHS.LIST_SESSION);
  };

  return (
    <AttendanceListNewView
      session={session}
      listAttendees={listAttendees}
      forceRefresh={forceRefresh}
      onSignAttendance={handleSignAttendance}
      onDeleteAttendance={handleDeleteAttendance}
      onGenerateDocument={handleGenerateDocument}
      onBack={handleBack}
      onCreateViewer={handleCreateViewer}
    />
  );
};

AttendanceListNewContainer.propTypes = {
  uuid: PropTypes.string.isRequired,
  session: PropTypes.object.isRequired,
};

export default AttendanceListNewContainer;
